export default {
  sitenameTH: "MEA",
  sitenameEN: "MEA",
};
